var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('b-row',[_c('Header'),_c('b-col',{staticClass:"left-side",attrs:{"cols":"2"}},[_c('PostDiceNav')],1),_c('b-col',{staticClass:"right-side"},[_c('Requisition')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }